<template>
  <div class="common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <!-- ei: '活动信息', -->
      <span>{{ $t('newApp.activityInfo.ei') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <!-- noa: '活动名称', -->
            <div class="label">{{ activityData.marketingForm === 1 ? $t('industryReport.hdxx.hdmc') : $t('industryReport.hdxx.yxzt') }}</div>

            <commonTooltip class="text" ref-name="activityDataActivityName" :content="activityData.activityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.businessUnit">
          <div>
            <!-- bu: '业务单元', -->
            <div class="label">{{ $t('industryReport.hdxx.ywdy') }}</div>

            <commonTooltip
              class="text"
              ref-name="activityDataBusinessUnit"
              :content="activityData.businessUnit"
            />
          </div>
        </el-col>
        <!-- 营销形式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.yxxs') }}</div>
            <div class="text">{{ activityData.marketingFormName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityClassification">
          <div>
            <!-- coa: '活动分类', -->
            <div class="label">{{ $t('industryReport.hdxx.hdfl') }}</div>

            <div class="text">{{ activityData.activityClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.relatedActivityName && activityData.relatedActivityCode && hdActiveValue">
          <div>
            <div class="label">{{ activityData.relationActivityName }}</div>
            <commonTooltip class="text" ref-name="activityDataRelatedActivityName" :content="hdActiveValue" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityForms">
          <div>
            <!-- foa:活动形式 -->
            <div class="label">{{ $t('industryReport.hdxx.hdxs') }}</div>

            <div class="text">{{ activityData.activityForms }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.organizer">
          <div>
            <!-- Organizer：主办方 -->
            <div class="label">{{ $t('industryReport.hdxx.zbf') }}</div>

            <div class="text">{{ activityData.organizer }}</div>
          </div>
        </el-col>
        <!-- 主要目标对象 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.targetObject">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.zymbdx') }}</div>

            <div class="text">{{ formatTargetObject(activityData.targetObject, activityData.targetObjectOther) }}</div>
          </div>
        </el-col>
        <!-- 品推支持 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.brandPromotionSupport">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ps') }}</div>
            <div class="text">{{ activityData.brandPromotionSupport }}</div>
          </div>
        </el-col>
        <!-- 举办城市 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.organizer">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.jbcs') }}</div>

            <div class="text">{{ activityData.city }}</div>
          </div>
        </el-col>
        <!-- 预计开始时间 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
            <div class="text">{{ activityData.expectStartDate }}</div>
          </div>
        </el-col>
        <!-- 预计结束时间 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
            <div class="text">{{ activityData.expectEndDate }}</div>
          </div>
        </el-col>
        <!-- 面向行业 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.mxhy') }}</div>

            <div class="text">{{ activityData.targetIndustryName }}</div>
          </div>
        </el-col>
        <!-- 远程poc -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportRemotePoc">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.rp') }}</div>
            <div class="text">{{ activityData.reportRemotePoc }}</div>
          </div>
        </el-col>
        <!-- 联合精钻活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportUnitedDiamondActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jra') }}</div>
            <div class="text">{{ activityData.reportUnitedDiamondActivity }}</div>
          </div>
        </el-col>
        <!-- 圈子活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportCircleActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ca') }}</div>
            <div class="text">{{ activityData.reportCircleActivity }}</div>
          </div>
        </el-col>
        <!-- 模板参观 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportTemplateVisit">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mv') }}</div>
            <div class="text">{{ activityData.reportTemplateVisit }}</div>
          </div>
        </el-col>
        <!-- 样机演示/体验 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportMachineDemo">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.machineDemo') }}</div>
            <div class="text">{{ activityData.reportMachineDemo }}</div>
          </div>
        </el-col>
        <!-- 活动内容涉及产品线 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="24" :xl="24" v-if="echoData.mactProductLineList && echoData.mactProductLineList.length > 0">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.hdsjcpx') }}</div>
            <div class="text">{{ activityData.productlineSupplement }}</div>
          </div>
        </el-col>
        <!-- 战略产品 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactCommunicationScenarioList && echoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ comscValue }}</div>
            <div class="text">{{ activityData.communicationScenarioList }}</div>
          </div>
        </el-col>
        <!-- 活动背景&目的 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="activityData.marketingForm === 1 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
            <div class="text">{{ activityData.activityBackgroundPurpose }}</div>
          </div>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.tnoptbi') }}</div>
            <div class="text">{{ activityData.inviterNum }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.targetObject">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mta') }}</div>
            <div class="text">{{ activityData.targetObject }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.toa') }}</div>
            <div class="text">{{ activityData.activityType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.qdMeetingSegment">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cms') }}</div>
            <div class="text">{{ activityData.qdMeetingSegment }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ps') }}</div>
            <div class="text">{{ activityData.brandPromotionSupport }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hc') }}</div>
            <div class="text">{{ activityData.city }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
            <div class="text">{{ activityData.expectStartDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
            <div class="text">{{ activityData.expectEndDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityBaseName">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdjd') }}</div>
            <div class="text">{{ activityData.activityBaseName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityBaseContactInformation">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jdlx') }}</div>
            <div class="text">{{ activityData.activityBaseContactInformation }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.salerDeptCode && activityData.salerDeptCode.indexOf('000063') === 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jma') }}</div>
            <div class="text">{{ activityData.isUnionMarket ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ic') }}</div>
            <div class="text">{{ activityData.isInternationalQd ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cst') }}</div>
            <div class="text">{{ activityData.unionChannelType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cn') }}</div>
            <div class="text">{{ activityData.unionChannelName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.csl') }}</div>
            <div class="text">{{ activityData.activityLevelName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityClassificationCode === 'AC_06'">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.dynags') }}</div>
            <div class="text">{{ activityData.needOrganizer ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.budgetAmount">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ba') }}</div>
            <div class="text">{{ activityData.budgetAmount }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="activityData.organizerReason">
          <div>
            <div class="label">{{ $t('approvalCenter.ReasonsApplication') }}</div>
            <div class="text">{{ activityData.organizerReason }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.remotePoc">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.rp') }}</div>
            <div class="text">{{ activityData.remotePoc }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.unitedDiamondActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jra') }}</div>
            <div class="text">{{ activityData.unitedDiamondActivity }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.circleActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ca') }}</div>
            <div class="text">{{ activityData.circleActivity }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.templateVisit">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mv') }}</div>
            <div class="text">{{ activityData.templateVisit }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactModuleList && echoData.mactModuleList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.teietcs') }}</div>
            <div class="text">{{ activityData.mactModuleList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactProductLineList && echoData.mactProductLineList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.artpl') }}</div>
            <div class="text">{{ activityData.productlineSupplement }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactCommunicationScenarioList && echoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ comscValue }}</div>
            <div class="text">{{ activityData.communicationScenarioList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactAgendaList && echoData.mactAgendaList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.agenda') }}</div>
            <div class="text">{{ activityData.agendaList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
            <div class="text">{{ activityData.activityBackgroundPurpose || '--' }}</div>
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { isNotEmpty } from '../../../../../utils/utils';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { targetObjectDisplayMixin } from '@/views/newApplicationForm/mixins/targetObjectMixin';

export default {
  mixins: [targetObjectDisplayMixin],
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      activityData: {},
      lang: localStorage.getItem('lang') || 'zh-CN',
      comscValue: ''
    };
  },
  components: {
    commonTooltip
  },
  computed: {
    hdActiveValue () {
      let value = '';
      switch (this.activityData.activityClassificationCode) {
      case 'AC_02':
      case 'AC_03':
        value = this.activityData.hqActivityName;
        break;
      case 'AC_01':
        value = this.activityData.relatedActivityName;
        break;
      }
      return value;
    }
  },
  mounted () {
    this.activityData = {
      ...this.echoData.marketActivityExpand,
      ...this.echoData.marketActivity
    };
    switch (this.activityData.activityClassificationCode) {
      case 'AC_02':
      case 'AC_03':
        this.activityData.relationActivityName = this.$t('home.ha');
        break;
      case 'AC_01':
        this.activityData.relationActivityName = this.$t('newApp.activityInfo.ta');
        break;
    }
    // 原活动分层逻辑废弃，暂时注释掉
    // switch (this.activityData.activityLevel) {
    //   case 'A':
    //      this.activityData.activityLevelName = 'A类重点活动';
    //     break;
    //   case 'B':
    //     this.activityData.activityLevelName = 'B类小型会议';
    //     break;
    //   case 'C':
    //      this.activityData.activityLevelName = 'C类关系活动';
    //     break;
    //     case 'D':
    //      this.activityData.activityLevelName = 'D类数字营销';
    //     break;
    // }
    // 营销形式数据处理
    // 营销形式（1-市场活动 2-数字营销（内容营销））
    if (this.echoData.marketActivityExpand.marketingForm) {
      this.activityData.marketingFormName = this.echoData.marketActivityExpand.marketingForm === 1 ? this.$t('industryReport.hybblb.cxtj.schd') : this.$t('industryReport.hybblb.cxtj.szyx');
    }
    if (this.echoData.marketActivityExpand.invitingParty) {
      this.activityData.invitingPartyName = this.echoData.marketActivityExpand.invitingParty === 2 ? this.$t('industryReport.hybblb.bxxq.hyzzyq') : this.$t('industryReport.hybblb.bxxq.qyyq');
    }
    // isNationalRelease: 1 是，0 否;
    this.activityData.isNationalReleaseName = this.echoData.marketActivity.isNationalRelease === 1 ? this.$t('btn.Yes') : this.$t('btn.No');
    // "targetIndustry": "",  // 面向行业（1-高职教 2-普教 3-医疗 4-企业 5-政府 6-AIGC 7-智能建筑及ICT）
    // if (this.echoData.marketActivityExpand.targetIndustry) {
    //   switch (this.echoData.marketActivityExpand.targetIndustry) {
    //     case 1:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.gzj');
    //       break;
    //     case 2:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.pj');
    //       break;
    //     case 3:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.yl');
    //       break;
    //     case 4:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.qy');
    //       break;
    //     case 5:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.zw');
    //       break;
    //     case 6:
    //       this.activityData.targetIndustryName = 'AIGC';
    //       break;
    //     case 7:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.znbj');
    //       break;
    //   }
    // }
    // 活动预计板块
    if (this.echoData.mactModuleList && this.echoData.mactModuleList.length > 0) {
      this.activityData.mactModuleList = this.echoData.mactModuleList.map(item => {
        return item.moduleName;
      }).join('，');
    }
    // 产品线
    if (this.echoData.mactProductLineList && this.echoData.mactProductLineList.length > 0) {
      this.activityData.productlineSupplement = this.echoData.mactProductLineList.map(item => {
        if (item.productLineName.indexOf('其他') >= 0) {
          item.productLineName = item.customProductLine;
        }
        return item.productLineName;
      }).join('，');
    }
    if (isNotEmpty(this.echoData.mactCommunicationScenarioList)) {
      this.activityData.communicationScenarioList = this.echoData.mactCommunicationScenarioList.map(item => {
        return item.communicationScenarioName;
      }).join('，');
      let params = ['fb_communication_scenario'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          const list = res.data.fbCommunicationScenario.filter(item => item.flag);
          const index = list.findIndex(item => item.fieldKey === this.echoData.mactCommunicationScenarioList[0].communicationScenarioCode);
          if (index !== -1) {
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            this.comscValue = this.$t('newApp.activityInfo.comsc');
          }
        }
      });
    }
    if (isNotEmpty(this.echoData.mactAgendaList)) {
      this.activityData.agendaList = this.echoData.mactAgendaList.map(item => {
        return item.agendaName;
      }).join('，');
    }
  }
};
</script>

<style scoped>

</style>
